import React, { memo } from 'react';
import styled from 'styled-components';

import Button from '../../../Button';
import ToggleButtonsGroup from '../../../ToggleButtonsGroup';

import { LOG_RELATIONS as RELATIONS } from '../../../../constants';
import { ValueOf } from '@utils/tsUtils';

const DEFAULT_RELATION = RELATIONS.TICKET;
const relationValues = Object.values(RELATIONS);
const labels = {
  [RELATIONS.CLIENT]: 'Лог клиента',
  [RELATIONS.TICKET]: 'Лог тикета',
};

const { StyledButton } = ToggleButtonsGroup;

interface ILogRelations {
  className?: string;
  value: ValueOf<typeof RELATIONS>;
  onChange: (event: CustomEvent) => void;
}

const LogRelations = ({ value, onChange, ...rest }: ILogRelations) => (
  <StyledLogRelations {...rest}>
    <StyledTogglers required values={[value]} onChange={onChange}>
      {relationValues.map(relation => (
        <StyledToggleButton key={relation} value={relation} checked={value}>
          {labels[relation]}
        </StyledToggleButton>
      ))}
    </StyledTogglers>
  </StyledLogRelations>
);

LogRelations.defaultProps = {
  className: '',
  value: DEFAULT_RELATION,
  onChange: Function.prototype,
};

const StyledLogRelations = styled.div`
  min-width: 250px;
`;

const StyledTogglers = styled(ToggleButtonsGroup)`
  background-color: #f5f3f2;
  border-radius: 4px;
  display: flex;
  height: auto;

  ${StyledButton} {
    flex: 1;
    border: 4px solid #f5f3f2;
    border-radius: 4px;
    line-height: 32px;

    &:first-child {
      border-left: 4px solid #f5f3f2;
      border-right: none;
      border-radius: 4px;
    }

    &:last-child {
      border-left: none;
      border-right: 4px solid #f5f3f2;
      border-radius: 4px;
    }
  }
`;

const StyledToggleButton = styled(Button)`
  background: transparent;
  ${props =>
    props.checked &&
    `
    background: white;
  `}
`;

export default memo(LogRelations);
